module.exports = __webpack_public_path__ + "img/Thinking.5e602c75.gif";